module.exports = __webpack_public_path__ + "static/media/sum.56e94522.png";